import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

  export async function bootstrapApp(): Promise<void> {
    if (environment.production) {
      enableProdMode();
    }
    try {
      await platformBrowserDynamic().bootstrapModule(AppModule);
    } catch (error) {
      console.error('Error bootstrapping Angular app:', error);
    }
  }